import { AgGridService } from "@topline/services/agGridService";
import { Gen } from "@topline/services/api";
import { ApiClient, wrapPromiseWithStatus } from "@topline/services/apiService";
import { stripClasses } from "../../../Utils/commonJsUtils";

export class ForecastService {
    static componentName = "ForecastService";
    static $inject = [AgGridService.componentName, ApiClient.componentName, "$http"];

    constructor(
        protected agGridService: AgGridService,
        protected apiClient: ApiClient,
        protected $http: ng.IHttpService
    ) {}

    create() {
        return this.apiClient.createForecast();
    }

    initialize(id: number, data: $TSFixMe, name: string) {
        return this.apiClient
            .initializeForecast(
                id,
                stripClasses({
                    jsonData: data,
                    name,
                    forecastId: id
                }) as $TSFixMe
            )
            .then((response: $TSFixMe) => {
                this.setCanEditCombined(response);
                return response;
            });
    }

    save(id: number, data: $TSFixMe) {
        return this.apiClient.updateForecast(id, stripClasses(data)).then((response: $TSFixMe) => {
            this.setCanEditCombined(response);
            return response;
        });
    }

    get(forecastId: number) {
        return wrapPromiseWithStatus(this.apiClient.getForecastById(forecastId)).then(response => {
            if (response.data && !response.data.jsonData) {
                response.data.jsonData = {} as unknown as $TSFixMe;
            }
            this.setCanEditCombined(response.data);
            return response;
        });
    }

    isMlModelEnabled(method: $TSFixMe) {
        return this.apiClient.isMLEnabled(method);
    }

    updateName(forecastId: number, name: string) {
        const updateNameCommand = {
            name: name
        };

        return wrapPromiseWithStatus(this.apiClient.updateForecastName(forecastId, updateNameCommand));
    }

    saveAsNew(forecastId: number, name: string) {
        const saveAsNewCommand = {
            name: name
        };
        return this.apiClient.saveForecastAsNew(forecastId, saveAsNewCommand);
    }

    getRisk() {
        return this.apiClient.getForecastRisks();
    }

    remove(id: number) {
        return this.apiClient.deleteForecast(id);
    }

    getForecastMarketDump(forecastId: number) {
        return wrapPromiseWithStatus(this.apiClient.getForecastMarketDump(forecastId));
    }

    searchForecast(filter: $TSFixMe) {
        return this.apiClient.simpleForecastSearch(filter.name, filter.budgetYear, filter.showMy);
    }

    getCorrectionAfterDefenceForecastVaues(forecastId: number) {
        return this.apiClient.getCorrection(forecastId);
    }

    loadMarketMlModels(forecastId: number) {
        return this.apiClient.getMlModelForForecast(forecastId);
    }

    private setCanEditCombined(response: $TSFixMe): $TSFixMe {
        const forecastMetadata = response;
        forecastMetadata.canEditCombinedConditions =
            (forecastMetadata.isEditable || forecastMetadata.isEditableAsApproved) &&
            !forecastMetadata.hasCorrectionAfterDefece;
        forecastMetadata.isEditable = forecastMetadata.isEditable && !forecastMetadata.hasCorrectionAfterDefece;
        forecastMetadata.isEditableAsApproved =
            forecastMetadata.isEditableAsApproved && !forecastMetadata.hasCorrectionAfterDefece;
        return response;
    }
}

angular.module("topline.services").service(ForecastService.componentName, ForecastService);
